
import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCaption
} from "@/components/ui/table";
import { CustomerData } from '@/hooks/admin/types';
import CustomerTableHeaders from './table/CustomerTableHeaders';
import CustomerTableRow from './table/CustomerTableRow';

interface CustomerTableProps {
  customers: CustomerData[];
  handleSort: (column: keyof CustomerData) => void;
  sortColumn: keyof CustomerData;
  sortDirection: 'asc' | 'desc';
  updateCustomerPlan: (subscriptionId: string, newPlan: string) => Promise<boolean>;
  createCustomerSubscription: (userId: string, plan: string) => Promise<boolean>;
  cancelCustomerSubscription: (userId: string, stripeSubscriptionId: string | null) => Promise<boolean>;
}

const CustomerTable: React.FC<CustomerTableProps> = ({ 
  customers, 
  handleSort, 
  sortColumn, 
  sortDirection,
  updateCustomerPlan,
  createCustomerSubscription,
  cancelCustomerSubscription
}) => {
  return (
    <Table>
      <TableCaption>A list of your customers.</TableCaption>
      
      <CustomerTableHeaders 
        handleSort={handleSort} 
        sortColumn={sortColumn} 
        sortDirection={sortDirection} 
      />
      
      <TableBody>
        {customers.map((customer) => (
          <CustomerTableRow
            key={customer.id}
            customer={customer}
            updateCustomerPlan={updateCustomerPlan}
            createCustomerSubscription={createCustomerSubscription}
            cancelCustomerSubscription={cancelCustomerSubscription}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default CustomerTable;
